import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleTranslateButton } from 'shared/ui/toggle-translate-button';
import { RoleListPanel } from '../components/role-list-panel';

/**
 * Route-level page for /management-role.
 * Rendered directly by React Router — may use the Page suffix.
 */
const RoleListPage = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <div className="w-full flex flex-wrap items-center py-5">
        <div className="w-1/2">
          <p className="text-lg font-semibold pt-8 pl-6 pb-4">
            {t('management_role')}
          </p>
        </div>
        <div className="w-1/2 flex justify-end px-6 gap-2">
          <ToggleTranslateButton className="!h-10" />
        </div>
      </div>

      <div className="flex-grow overflow-auto px-6">
        <RoleListPanel />
      </div>
    </>
  );
};

export default RoleListPage;
